import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowLeft, Music, Calendar, Users, Truck, Lightbulb, Video } from 'lucide-react';

export const InnovaScenePage = () => {
  const services = [
    {
      icon: <Music className="w-6 h-6" />,
      title: 'Sonorisation professionnelle',
      description: 'Systèmes audio de haute qualité pour tous types d\'événements'
    },
    {
      icon: <Video className="w-6 h-6" />,
      title: 'Équipement audiovisuel',
      description: 'Écrans LED, projecteurs, caméras et équipement de diffusion'
    },
    {
      icon: <Lightbulb className="w-6 h-6" />,
      title: 'Éclairage scénique',
      description: 'Éclairages professionnels et effets lumineux pour vos événements'
    },
    {
      icon: <Calendar className="w-6 h-6" />,
      title: 'Gestion d\'événements',
      description: 'Planification et coordination complète de vos événements'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Équipe technique',
      description: 'Techniciens expérimentés pour l\'installation et la gestion'
    },
    {
      icon: <Truck className="w-6 h-6" />,
      title: 'Livraison et installation',
      description: 'Service clé en main avec transport et montage inclus'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50">
      <Header />
      
      <main className="max-w-6xl mx-auto px-4 py-20">
        <Button
          onClick={() => window.location.href = '/'}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Button>

        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="inline-block p-6 bg-gradient-to-br from-purple-600 to-purple-800 rounded-full mb-6">
            <Music className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-purple-700 to-blue-600 bg-clip-text text-transparent">
            Innova-Scene
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-4">
            Gestion événementiel et location de matériel audiovisuel
          </p>
          <p className="text-lg text-purple-600 font-semibold">
            En collaboration avec SPL Sonorisation
          </p>
        </div>

        {/* Partnership Banner */}
        <div className="bg-gradient-to-r from-purple-100 to-blue-100 rounded-2xl p-6 mb-12 border-2 border-purple-200">
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-purple-800">Innova-Solution</h3>
              <p className="text-sm text-purple-600">Technologie & Gestion</p>
            </div>
            <div className="text-3xl text-purple-600">+</div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-purple-800">SPL Sonorisation</h3>
              <p className="text-sm text-purple-600">Expertise Audiovisuelle</p>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-800 rounded-lg flex items-center justify-center mb-4 text-white">
                {service.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Types of Events */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
            Types d'événements
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 bg-purple-50 rounded-xl">
              <h3 className="font-bold text-gray-800 mb-3">🎭 Événements corporatifs</h3>
              <p className="text-gray-600">Conférences, séminaires, lancements de produits</p>
            </div>
            <div className="p-6 bg-blue-50 rounded-xl">
              <h3 className="font-bold text-gray-800 mb-3">🎉 Événements privés</h3>
              <p className="text-gray-600">Mariages, anniversaires, galas</p>
            </div>
            <div className="p-6 bg-pink-50 rounded-xl">
              <h3 className="font-bold text-gray-800 mb-3">🎵 Concerts et spectacles</h3>
              <p className="text-gray-600">Performances musicales, spectacles de scène</p>
            </div>
            <div className="p-6 bg-orange-50 rounded-xl">
              <h3 className="font-bold text-gray-800 mb-3">🏛️ Événements publics</h3>
              <p className="text-gray-600">Festivals, foires, événements communautaires</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Organisez un événement mémorable
          </h3>
          <p className="mb-6 text-lg">
            Notre équipe d'experts est prête à vous accompagner dans votre projet
          </p>
          <Button
            onClick={() => window.location.href = '/#contact'}
            className="bg-white text-purple-700 hover:bg-purple-50 px-8 py-6 text-lg"
          >
            Demander un devis
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};
